export default __webpack_public_path__ + "static/media/OMA.81a1d231.svg";